/* screens/dev/UiKitParts6.jsx — витрина (часть 6, S12): Авторизация и онбординг.
   PasswordInput, StrengthMeter (живой ввод), ScreenHeader, BackLink + ссылки на полные
   экраны (AuthLayout/LeftVisual/InviteAccept/OnboardingWizard открываются по deep-link). */

import React from 'react';
import { Button } from '../../components/ui/Button.jsx';
import { BackLink } from '../../components/ui/Buttons.jsx';
import { Field, PasswordInput, StrengthMeter } from '../../components/ui/Field.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { ScreenHeader } from '../../components/ui/Metric.jsx';
import { RR } from '../../lib/router.jsx';
import { UiKitSection as Section, UiKitStateBox as StateBox } from './UiKitParts1.jsx';

  const { useState } = React;
  const { Link } = RR;

  const SCREENS = [
    { to: '/signin', label: 'Вход', note: '/signin — сплит + LeftVisual' },
    { to: '/signup', label: 'Регистрация', note: '/signup — StrengthMeter + живые ссылки' },
    { to: '/forgot', label: 'Сброс пароля', note: '/forgot → /email-sent (кулдаун)' },
    { to: '/reset-password?uid=1&token=abc', label: 'Новый пароль', note: '/reset-password' },
    { to: '/verify-email?uid=1&token=ok', label: 'Подтверждение email', note: '/verify-email (ok)' },
    { to: '/verify-email?uid=1&token=bad', label: 'Verify · ошибка', note: 'token=bad → ошибка' },
    { to: '/invite/accept/ready_match', label: 'Приглашение · match', note: '/invite/accept/:token' },
    { to: '/invite/accept/needs_register', label: 'Приглашение · регистрация', note: 'ветка needs_register' },
    { to: '/invite/accept/expired', label: 'Приглашение · истекло', note: 'терминальная ветка' },
    { to: '/onboarding', label: 'Онбординг', note: '/onboarding — 2 шага' },
    { to: '/legal/offer', label: 'Оферта', note: '/legal/offer (живая ссылка)' },
  ];

  function AuthSection() {
    const [pw, setPw] = useState('Borsch2026!');

    return (
      <Section id="auth" title="Авторизация и онбординг (S12)"
        sub="Адаптивная AuthLayout (сплит c LeftVisual на >720, одна колонка ≤720 — фикс №41), формы входа/регистрации/сброса, статус-экраны подтверждения, приглашение (7 веток) и лёгкий онбординг. Компоненты ниже — общие; полные экраны открываются по deep-link.">

        <StateBox label="ScreenHeader · акцентный заголовок (вход/регистрация) + вариант с eyebrow">
          <div className="stack stack-16">
            <ScreenHeader title="Вход" className="screen-header--accent" />
            <ScreenHeader eyebrow="Регистрация" title="Заведём аккаунт." subtitle="Подзаголовок поясняет шаг." />
          </div>
        </StateBox>

        <StateBox label="PasswordInput + StrengthMeter · живой ввод (4 сегмента: слабый/средний/хороший/сильный)">
          <div className="stack stack-8" style={{ maxWidth: 360 }}>
            <Field label="Пароль" htmlFor="uk-pw">
              <PasswordInput id="uk-pw" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Введите пароль" />
            </Field>
            <StrengthMeter value={pw} />
          </div>
        </StateBox>

        <StateBox label="BackLink · навигация на уровень вверх">
          <BackLink to="/signin">Войти</BackLink>
        </StateBox>

        <StateBox label="Полные экраны (открываются по deep-link)">
          <div className="auth-uikit-links">
            {SCREENS.map((s) => (
              <Link key={s.to} to={s.to} className="auth-uikit-link">
                <Icon name="external-link" size={15} />
                <span className="auth-uikit-link__text">
                  <span className="auth-uikit-link__label">{s.label}</span>
                  <span className="auth-uikit-link__note num">{s.note}</span>
                </span>
              </Link>
            ))}
          </div>
        </StateBox>
      </Section>
    );
  }

export { AuthSection };
